




















































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import TanggalGizi from "@/components/gizi/TanggalGizi.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import OrderGiziSvc from "@/services/OrderGizi";
import { SHIFT_ORDER_GIZI } from "@/constants/gizi";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import {
  RekapOrderGiziFilter,
  RekapOrderGiziMeta,
  RekapOrderGiziOpsi,
  RekapOrderGiziRingkasan,
  RekapOrderGiziRow,
  RentangTanggal
} from "@/types/orderGizi";

const MAX_PERIODE_HARI = 31;

function filterAwal(): RekapOrderGiziFilter {
  const hariIni = localISODate();
  return {
    tgl_start: hariIni,
    tgl_end: hariIni,
    unit: [],
    shift: null,
    diit: [],
    pemesan: null,
    q: ""
  };
}

@Component({
  components: { TanggalGizi, UnitRuangPicker }
})
export default class OrderGiziRekapPage extends Vue {
  filter: RekapOrderGiziFilter = filterAwal();
  periode: RentangTanggal | null = {
    start: this.filter.tgl_start,
    end: this.filter.tgl_end
  };
  filterTermuat: RekapOrderGiziFilter | null = null;
  halamanTermuat = 1;
  perHalamanTermuat = 25;
  opsi: RekapOrderGiziOpsi | null = null;
  rows: RekapOrderGiziRow[] = [];
  meta: RekapOrderGiziMeta | null = null;
  ringkasan: RekapOrderGiziRingkasan | null = null;
  opsiTabel = { page: 1, itemsPerPage: 25 };
  memuat = false;
  memuatPdf = false;
  memuatExcel = false;
  tokenMuat = 0;

  readonly shiftList = SHIFT_ORDER_GIZI;

  readonly headers = [
    { text: "No", value: "no", width: "48" },
    { text: "Tanggal / Shift", value: "tanggal_label", width: "110" },
    { text: "Bangsal", value: "unit_nama" },
    { text: "Pasien", value: "pasien_nama" },
    { text: "Diit", value: "diit" },
    { text: "Petugas Pemesan", value: "pemesan_nama" }
  ];

  get opsiShift() {
    return SHIFT_ORDER_GIZI.map(s => ({
      value: s.value,
      text: `${s.text} (${s.jam})`
    }));
  }

  get perHalamanOpsi(): number[] {
    return this.opsi ? this.opsi.per_halaman : [25, 50, 100];
  }

  get maxPeriodeHari(): number {
    return this.opsi ? this.opsi.max_periode_hari : MAX_PERIODE_HARI;
  }

  get filterAktif(): RekapOrderGiziFilter {
    return {
      tgl_start: this.periode ? this.periode.start : "",
      tgl_end: this.periode ? this.periode.end : "",
      unit: [...(this.filter.unit || [])],
      shift: this.filter.shift || null,
      diit: [...(this.filter.diit || [])],
      pemesan: this.filter.pemesan || null,
      q: (this.filter.q || "").trim()
    };
  }

  get filterBerubah(): boolean {
    return (
      !!this.filterTermuat &&
      JSON.stringify(this.filterAktif) !== JSON.stringify(this.filterTermuat)
    );
  }

  get alasanPeriode(): string | null {
    const awal = parseLocalDate(this.filterAktif.tgl_start);
    const akhir = parseLocalDate(this.filterAktif.tgl_end);
    if (!awal || !akhir) return "Tanggal wajib diisi.";

    const hari = Math.round((akhir.getTime() - awal.getTime()) / 86400000);
    if (hari < 0) return "Tanggal akhir tidak boleh sebelum tanggal awal.";
    if (hari > this.maxPeriodeHari) {
      return `Rentang maksimal ${this.maxPeriodeHari} hari.`;
    }
    return null;
  }

  get tiles() {
    const r = this.ringkasan;
    return [
      { label: "Total pasien", nilai: r ? r.total : 0, warna: "teal--text text--darken-3" },
      ...SHIFT_ORDER_GIZI.map(s => ({
        label: `Shift ${s.text}`,
        nilai: r ? r.per_shift[s.value] : 0,
        warna: "grey--text text--darken-3"
      })),
      { label: "Jenis diit", nilai: r ? r.per_diit.length : 0, warna: "indigo--text" },
      { label: "Bangsal", nilai: r ? r.per_bangsal.length : 0, warna: "indigo--text" }
    ];
  }

  mounted() {
    this.muatOpsi();
    this.tampilkan();
  }

  @Watch("periode")
  onGantiPeriode() {
    this.muatOpsi();
  }

  @Watch("opsiTabel", { deep: true })
  onGantiHalaman(val: { page: number; itemsPerPage: number }) {
    if (!this.filterTermuat) return;
    if (val.page === this.halamanTermuat && val.itemsPerPage === this.perHalamanTermuat) return;

    const halaman = val.itemsPerPage !== this.perHalamanTermuat ? 1 : val.page;
    this.muat(this.filterTermuat, halaman);
  }

  async muatOpsi() {
    if (this.alasanPeriode) return;

    try {
      this.opsi = await OrderGiziSvc.rekapOpsi(
        this.filterAktif.tgl_start,
        this.filterAktif.tgl_end
      );
    } catch {
      return;
    }
  }

  tampilkan() {
    if (this.alasanPeriode) return;
    this.muat(this.filterAktif, 1);
  }

  muatUlang() {
    if (!this.filterTermuat) {
      this.tampilkan();
      return;
    }
    this.muat(this.filterTermuat, this.halamanTermuat);
  }

  async muat(filter: RekapOrderGiziFilter, halaman: number) {
    const perHalaman = this.opsiTabel.itemsPerPage > 0 ? this.opsiTabel.itemsPerPage : 25;
    const token = ++this.tokenMuat;
    this.memuat = true;
    try {
      const res = await OrderGiziSvc.rekap(filter, halaman, perHalaman);
      if (token !== this.tokenMuat) return;

      this.filterTermuat = filter;
      this.halamanTermuat = res.meta.page;
      this.perHalamanTermuat = res.meta.per_page;
      this.rows = res.data;
      this.meta = res.meta;
      this.ringkasan = res.ringkasan;
      if (this.opsiTabel.page !== res.meta.page) {
        this.opsiTabel = { ...this.opsiTabel, page: res.meta.page };
      }
    } catch {
      return;
    } finally {
      if (token === this.tokenMuat) {
        this.memuat = false;
      }
    }
  }

  reset() {
    this.filter = filterAwal();
    this.periode = { start: this.filter.tgl_start, end: this.filter.tgl_end };
    this.tampilkan();
  }

  async cetakPdf() {
    if (!this.filterTermuat) return;

    this.memuatPdf = true;
    try {
      await OrderGiziSvc.rekapPdf(this.filterTermuat);
    } catch {
      return;
    } finally {
      this.memuatPdf = false;
    }
  }

  async unduhExcel() {
    if (!this.filterTermuat) return;

    this.memuatExcel = true;
    try {
      await OrderGiziSvc.rekapExcel(this.filterTermuat);
    } catch {
      return;
    } finally {
      this.memuatExcel = false;
    }
  }
}
